export default "__VITE_ASSET__w6Sf0oc6__"